import { Route } from 'types/route.type';

import BluViuNutrition from 'views/bluviu-nutrition/components/bluviu-nutrition';
import EditScenario from './components/edit-scenario';
import ViewScenarioResult from './components/view-results/view-scenario-result';

export const routes: Route[] = [
  //   {
  //     path: '/bluviu-nutrition/scenarios',
  //     component: ListScenarios,
  //     id: 'bluViuNutrition.navigation.listScenarios',
  //   },
  {
    path: '/bluviu-nutrition/:tab/:globalSiteId?',
    component: BluViuNutrition,
    id: 'bluViuNutrition.navigation.listScenarios',
  },
  {
    path: '/bluviu-nutrition/:tab(scenarios)/:globalSiteId?/:scenarioId',
    component: EditScenario,
  },
  {
    path: '/bluviu-nutrition/:tab/:globalSiteId?/:scenarioId/result',
    component: ViewScenarioResult,
    id: 'bluViuNutrition.navigation.viewScenarioResultGt2',
  },
];
